module.exports = __webpack_public_path__ + "img/8step-02-02-1_ergebnis.25da6ffb.webp";